import { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { EASE } from "@/components/Reveal";

const links = [
  { label: "Services", to: "/#what-we-do", isAnchor: true },
  { label: "Blogs", to: "/blogs" },
  { label: "Contact Us", to: "/contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goServices = (e) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname === "/") {
      const el = document.querySelector("#what-we-do");
      if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
    } else {
      navigate("/#what-we-do");
    }
  };

  return (
    <motion.header
      className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-8 pt-4"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
    >
      <nav
        data-testid="main-navbar"
        className="site-container flex items-center justify-between rounded-[48px] px-8 sm:px-10 py-3 backdrop-blur-xl"
        style={{ background: "rgba(241, 241, 241, 0.7)", boxShadow: "0 8px 30px rgba(17,17,17,0.06)" }}
      >
        <Link
          to="/"
          data-testid="navbar-logo-link"
          className="flex items-center leading-none"
          onClick={() => {
            setOpen(false);
            if (location.pathname === "/") {
              if (window.__lenis) window.__lenis.scrollTo(0);
              else window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }}
        >
          <img src="/assets/logo.svg" alt="OPHO Digital" className="h-8 w-auto block" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a
            href="/#what-we-do"
            onClick={goServices}
            data-testid="nav-link-services"
            className="text-[16px] font-medium text-[#111] hover:text-[#8C5EBA] transition-colors duration-300"
          >
            Services
          </a>
          <NavLink
            to="/blogs"
            data-testid="nav-link-blogs"
            className={({ isActive }) =>
              `text-[16px] font-medium transition-colors duration-300 ${isActive ? "text-[#8C5EBA] font-semibold" : "text-[#111] hover:text-[#8C5EBA]"}`
            }
          >
            Blogs
          </NavLink>
          <NavLink
            to="/contact"
            data-testid="nav-link-contact"
            className={({ isActive }) =>
              `text-[16px] font-medium transition-colors duration-300 ${isActive ? "text-[#8C5EBA] font-semibold" : "text-[#111] hover:text-[#8C5EBA]"}`
            }
          >
            Contact Us
          </NavLink>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-[#111]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <motion.div
          data-testid="mobile-menu"
          className="md:hidden max-w-[1380px] mx-auto mt-2 rounded-3xl bg-white/95 backdrop-blur-xl shadow-xl p-6 flex flex-col gap-4"
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: EASE }}
        >
          <a href="/#what-we-do" onClick={goServices} className="text-lg font-medium">Services</a>
          <Link to="/blogs" onClick={() => setOpen(false)} className="text-lg font-medium">Blogs</Link>
          <Link to="/contact" onClick={() => setOpen(false)} className="text-lg font-medium">Contact Us</Link>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Navbar;
